/**
 * Texto da label de um airspace a partir do `code` do dataset.
 *
 * Os códigos vêm com underscores no lugar dos espaços (`CTA_BRASILIA_SETOR_1`),
 * então TODOS precisam virar espaço — trocar só o primeiro deixa underscore
 * visível na label de códigos com mais de uma palavra (típico de CTA e Setor de
 * CTA). Mesmo comportamento do pilotapp (`AirspaceFlatRecordMapper`).
 */
export const buildAirspaceCodeLabel = (code?: string): string | undefined =>
  typeof code === 'string' ? code.replace(/_/g, ' ') : undefined
